class SgSetsShop extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    this.bar = this.querySelector('[data-bar]');
    if (!this.track) return;

    this.prev.addEventListener('click', () => this.step(-1));
    this.next.addEventListener('click', () => this.step(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());

    // Arrastre con mouse (en táctil el scroll nativo ya funciona)
    let down = false, startX = 0, startLeft = 0, moved = false;
    this.track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = this.track.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; this.track.classList.add('is-drag'); }
      if (moved) this.track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      this.track.classList.remove('is-drag');
    });
    this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);

    this.update();
  }

  step(dir) {
    const card = this.track.querySelector('.sg-ss__item');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap) * 2, behavior: 'smooth' });
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const pos = this.track.scrollLeft;
    this.prev.disabled = pos <= 2;
    this.next.disabled = pos >= max - 2;
    const visible = max > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
    if (this.bar) {
      this.bar.style.width = (visible * 100) + '%';
      this.bar.style.transform = 'translateX(' + (max > 0 ? (pos / max) * (100 / visible - 100) : 0) + '%)';
    }
    this.classList.toggle('is-static', max <= 2);
  }
}
if (!customElements.get('sg-sets-shop')) customElements.define('sg-sets-shop', SgSetsShop);
